import forestIcon from "../../images/forest.svg";
import Modal from "../Modal";
import React from "react";
import styles from "./ElectronicCommunicationsAgreementModal.module.css";
import timerIcon from "../../images/timer.svg";

const strings = {
    confirm: "Confirm communication preference",
    question: "Would you like to receive statements and other communication electronically?",
    protectEnviro: "Protect the environment",
    saveTime: "Save Time",
    yes: "Yes",
    yesDescription: "I have read and accept the Electronic Communications Agreement",
    no: "No",
};

interface Focusable {
    focus: () => void;
}

type Props<T> = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (agreeToPaperless: boolean) => void;
    triggerElement: T | null;
};

export default function ElectronicCommunicationsAgreementModal<T extends Focusable>(
    props: Props<T>,
) {
    return (
        <Modal
            id="prompt-electronic-agreement"
            label={strings.confirm}
            bodyClassName={styles.container}
            isOpen={props.isOpen}
            onClose={props.onClose}
            onSubmit={() => props.onSubmit(true)}
            onSubmitLabel={strings.yes}
            onSubmitDescription={strings.yesDescription}
            onCancel={() => props.onSubmit(false)}
            onCancelLabel={strings.no}
            showCancelButton={true}
            isCancelButtonPrimary={true}
            triggerElement={props.triggerElement}
        >
            <div className={styles.question}>{strings.question}</div>
            <div className={styles.iconLine}>
                <img className={styles.icon} src={forestIcon} alt="" />
                <div>{strings.protectEnviro}</div>
            </div>
            <div className={styles.iconLine}>
                <img className={styles.icon} src={timerIcon} alt="" />
                <div>{strings.saveTime}</div>
            </div>
        </Modal>
    );
}
